import { type FC } from "react";
import { InputNumber, type InputNumberProps } from "antd";
import { ReactComponent as ArrowDropUpIcon } from "../../../../assets/images/arrow-drop-up-16.svg";
import { ReactComponent as ArrowDropDownIcon } from "../../../../assets/images/arrow-drop-down-16.svg";
import "./style.less";

const CONTROLS = {
  upIcon: <ArrowDropUpIcon aria-hidden />,
  downIcon: <ArrowDropDownIcon aria-hidden />,
};

const NumberInput: FC<InputNumberProps<number>> = ({ className, ...props }) => (
  <InputNumber<number>
    {...props}
    className={`rd-number-input ${className ?? ""}`}
    controls={CONTROLS}
  />
);

export default NumberInput;
